import { api } from "./customers";

export interface CustomerJourney {
  id: any;
  labName: string;
  email: string;
  phone: string;
  password: string;
  branchId: string;
}
export interface CustomerJourneymaster {
  id: any;
  customerJourneyName: any;
  createdAt: any;
  activeStatus: any;
  description: any;
  updatedAt: any;

  data: any;
  others: any;
}
export interface CustomerJourneyActive {
  data: CustomerJourneymaster[];
}

export interface IvfJourney {
  id: number;
  customerId: number;
  stepsId: string;
  stagesId: string;
  stepsname: string;
  stagesname: string;

  createdAt: string;
}

type CustomerJourneysResponse = CustomerJourney[];

export const LabManagementApi = api.injectEndpoints({
  endpoints: (build) => ({
    getMyLabsList: build.query<CustomerJourneysResponse, any>({
      query: ({ pagi, name }) => `lab?search=${name}`,
      providesTags: (result) =>
        result
          ? [
              ...result["data"]?.map(({ id }) => ({
                type: "LabManagement" as const,
                id,
              })),
              { type: "LabManagement", id: "LIST" },
            ]
          : [{ type: "LabManagement", id: "LIST" }],
    }),
    getTestOrders: build.query<CustomerJourneysResponse, any>({
      query: ({ pagi, name }) => `test_order_list?search=${name}`,
      providesTags: (result) =>
        result
          ? [
              ...result["data"]?.map(({ id }) => ({
                type: "LabManagement" as const,
                id,
              })),
              { type: "LabManagement", id: "LIST" },
            ]
          : [{ type: "LabManagement", id: "LIST" }],
    }),
    addMyLab: build.mutation<CustomerJourney, Partial<CustomerJourney>>({
      query: (body) => ({
        url: `lab`,
        method: "POST",
        body,
      }),
      transformResponse: (response: { data: CustomerJourney }, meta, arg) =>
        response.data,
    }),
    updateMyLab: build.mutation<
      void,
      Pick<CustomerJourney, "id"> & Partial<CustomerJourney>
    >({
      query: ({ id, ...patch }) => ({
        url: `lab/${id}`,
        method: "PUT",
        body: patch,
      }),
    }),
    deleteMyLab: build.mutation<{ success: boolean; id: number }, number>({
      query(id) {
        return {
          url: `lab/${id}`,
          method: "DELETE",
        };
      },
    }),
    getTestPackages: build.query<CustomerJourneysResponse, any>({
      query: ({ name }) => `test_packages?search=${name}`,
      providesTags: (result) =>
        result
          ? [
              ...result["data"]?.map(({ id }) => ({
                type: "TestPackage" as const,
                id,
              })),
              { type: "TestPackage", id: "LIST" },
            ]
          : [{ type: "TestPackage", id: "LIST" }],
    }),

    getTestOrderDetailsbyId: build.query<CustomerJourney, any>({
      query: (id) => `test_order_view_lab/${id}`,
      providesTags: ["Reports"],
      transformResponse: (response: { data: CustomerJourney }, meta, arg) =>
        response.data,
    }),

    //Update my lab status

    updateLabStatus: build.mutation<void, { id: any; activeStatus: any }>({
      query: ({ id, activeStatus }) => ({
        url: `lab_status/${id}`,
        method: "PUT",
        body: { activeStatus },
      }),
    }),
  }),
});

export const {
  useGetMyLabsListQuery,
  useAddMyLabMutation,
  useUpdateMyLabMutation,
  useUpdateLabStatusMutation,
  useDeleteMyLabMutation,
  useGetTestOrdersQuery,
  useGetTestOrderDetailsbyIdQuery,
  useGetTestPackagesQuery,
} = LabManagementApi;
